import React from 'react';
import { config } from 'config';
import { minutesFormat } from 'shared/utils';
import { statisticsActions } from 'core/Statistics';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    Card,
    InfoCard
} from 'mol-ui';
import {
    ColStyled,
    RatingContainer
} from './styled';
import {
    Container,
    Row
} from 'reactstrap';
import {
    PanelSection,
    Percentage,
    Rating,
    StatisticsLayout
} from 'views/components';
import {
    useDispatch,
    useSelector
} from 'hooks';
const { interconsult } = config;

const StatisticsVideocall = () => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        dashboardPatient,
        primaryColor
    } = useTheme();

    const {
        loading,
        videocall: {
            calls: {
                attended,
                not_attended,
                successful,
                total
            } = {},
            duration: {
                avg: avgDuration,
                total: totalDuration
            } = {},
            rating: {
                quality_call_caller,
                quality_call_doctor,
                quality_call_patient,
                session_call_caller,
                session_call_patient
            } = {},
            reason: {
                rejected,
                time_out
            } = {},
            waitings: {
                patient_turnaround_time,
                patient_waiting_duration
            } = {}
        }
    } = useSelector('statistics');

    const onFiltersChange = filters => {
        dispatch(statisticsActions.getStatisticsVideocall(filters));
    };

    const sessionCommons = {
        color: dashboardPatient,
        disabled: true
    };

    const qualityCommons = {
        color: primaryColor,
        disabled: true
    };

    return (
        <StatisticsLayout
            loading={ loading }
            title={ t('Videollamada') }
            onFiltersChange={ onFiltersChange }
        >
            <Container fluid>
                <Row>
                    <ColStyled lg={ 3 } md={ 6 } sm={ 12 }>
                        <InfoCard
                            caption={ t('Llamadas finalizadas') }
                            icon="done"
                            title={ (successful ?? 0).toString() }
                        />
                    </ColStyled>
                    <ColStyled lg={ 3 } md={ 6 } sm={ 12 }>
                        <InfoCard
                            caption={ t('Totales') }
                            icon="phone"
                            title={ (total ?? 0).toString() }
                        />
                    </ColStyled>
                    <ColStyled lg={ 3 } md={ 6 } sm={ 12 }>
                        <InfoCard
                            caption={ t('Atendidas') }
                            icon="phone_callback"
                            title={ (attended ?? 0).toString() }
                        />
                    </ColStyled>
                    <ColStyled lg={ 3 } md={ 6 } sm={ 12 }>
                        <InfoCard
                            caption={ t('No Atendidas') }
                            icon="phone_missed"
                            title={ (not_attended ?? 0).toString() }
                        />
                    </ColStyled>
                </Row>
                <Row>
                    <ColStyled md={ 4 } sm={ 12 }>
                        <Card>
                            <PanelSection title={ t('Espera del paciente') }>
                                <Percentage
                                    icon="access_time"
                                    text={ !!patient_waiting_duration ? minutesFormat(patient_waiting_duration) : t('Sin datos') }
                                    title={ t('Espera promedio') }
                                />
                                <Percentage
                                    icon="access_time"
                                    text={ !!patient_turnaround_time ? minutesFormat(patient_turnaround_time) : t('Sin datos') }
                                    title={ t('Espera promedio hasta interacción') }
                                />
                            </PanelSection>
                        </Card>
                    </ColStyled>
                    <ColStyled md={ 4 } sm={ 12 }>
                        <Card>
                            <PanelSection title={ t('Tiempo') }>
                                <Percentage
                                    icon="access_time"
                                    text={ !!avgDuration ? minutesFormat(avgDuration) : t('Sin datos') }
                                    title={ t('Tiempo Promedio') }
                                />
                                <Percentage
                                    icon="access_time"
                                    text={ !!totalDuration ? minutesFormat(totalDuration) : t('Sin datos') }
                                    title={ t('Tiempo Total') }
                                />
                            </PanelSection>
                        </Card>
                    </ColStyled>
                    <ColStyled md={ 4 } sm={ 12 }>
                        <Card>
                            <PanelSection title={ t('Motivo no atendida') }>
                                <Percentage
                                    icon="alarm"
                                    text={ !!time_out ? `${ time_out }%` : t('Sin datos') }
                                    title={ t('Time Out') }
                                />
                                <Percentage
                                    icon="call_missed"
                                    text={ !!rejected ? `${ rejected }%` : t('Sin datos') }
                                    title={ t('Rechazada') }
                                />
                            </PanelSection>
                        </Card>
                    </ColStyled>
                    {
                        (!!quality_call_doctor || quality_call_caller || !!quality_call_patient) &&
                        <ColStyled md={ 4 } sm={ 12 }>
                            <Card>
                                <PanelSection title={ t('Calidad de llamada') }>
                                    {
                                        !!quality_call_doctor &&
                                        <RatingContainer>
                                            <Rating
                                                { ...qualityCommons }
                                                stars={ quality_call_doctor }
                                                title={ t('Según el profesional') }
                                            />
                                        </RatingContainer>
                                    }
                                    {
                                        interconsult && !!quality_call_caller &&
                                        <RatingContainer>
                                            <Rating
                                                { ...qualityCommons }
                                                stars={ quality_call_caller }
                                                title={ t('Según el profesional externo') } />
                                        </RatingContainer>
                                    }
                                    {
                                        !!quality_call_patient &&
                                        <RatingContainer>
                                            <Rating
                                                { ...qualityCommons }
                                                stars={ quality_call_patient }
                                                title={ t('Según el paciente') } />
                                        </RatingContainer>
                                    }
                                </PanelSection>
                            </Card>
                        </ColStyled>
                    }
                    {
                        (!!session_call_patient || !!session_call_caller) &&
                        <ColStyled md={ 4 } sm={ 12 }>
                            <Card>
                                <PanelSection title={ t('Calidad de atención') }>
                                    {
                                        interconsult && !!session_call_caller &&
                                        <RatingContainer>
                                            <Rating
                                                { ...sessionCommons }
                                                stars={ session_call_caller }
                                                title={ t('Según el profesional externo') }
                                            />
                                        </RatingContainer>
                                    }
                                    {
                                        !!session_call_patient &&
                                        <RatingContainer>
                                            <Rating
                                                { ...sessionCommons }
                                                stars={ session_call_patient }
                                                title={ t('Según el paciente') }
                                            />
                                        </RatingContainer>
                                    }
                                </PanelSection>
                            </Card>
                        </ColStyled>
                    }
                </Row>
            </Container>
        </StatisticsLayout>
    );
};

StatisticsVideocall.propTypes = {

};

export default StatisticsVideocall;
